<template>
    <div id="corporate-view">
        <div class="row g-0 red-color justify-content-center text-white mt-4 pt-5 pb-5">
            <div class="col-8 text-left">
                <div style="font-size: 1.15rem;">
                    <p class="mb-0">{{ content1 }}</p>
                    <p class="mb-4">{{ content2 }}</p>
                    <p class="mb-0">{{ content3 }}</p>
                    <p class="mb-0">{{ content4 }}</p>
                </div>
            </div>
        </div>

        <div class="bg-black text-center text-white mt-4 pb-2 pt-3 fs-3">
            <div class="mb-0 pb-0 agency-signature-main">{{ signatureMain }} </div>
            <div class="mb-0 pt-0">{{ websiteUrl }} </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";

import { TEXT_KEYS } from "@/constants";

@Options({
  components: {
  }
})
export default class Corporate extends Vue {
  languageStore = useLanguageStore()

    get content1() {
        return this.languageStore.text(TEXT_KEYS.AGENCY_CONTENT_1)
    }

    get content2() {
        return this.languageStore.text(TEXT_KEYS.AGENCY_CONTENT_2)
    }

    get content3() {
        return this.languageStore.text(TEXT_KEYS.AGENCY_CONTENT_3)
    }

    get content4() {
        return this.languageStore.text(TEXT_KEYS.AGENCY_CONTENT_4)
    }

    get signatureMain() {
        return this.languageStore.text(TEXT_KEYS.AGENCY_SIGNATURE_MAIN)
    }

    get websiteUrl() {
        return this.languageStore.text(TEXT_KEYS.WEBSITE_URL)
    }
}
</script>

<style lang="stylus">
</style>